import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "pathBuilder",
})
export class PathBuilderPipe implements PipeTransform {
  transform(path: string, args: object): string {
    const chunksOfPath = path.split("/");
    const builtPath = chunksOfPath.map((c) => (c.startsWith(":") ? args[c.substring(1)] : c)).join("/");
    return builtPath;
  }
}

@Pipe({
  name: "absolutePathBuilder",
})
export class AbsolutePathBuilderPipe implements PipeTransform {
  transform(path: string, args: object): string {
    return args[path.substring(1)];
  }
}
